import { ISnackbarStore } from './types';

const initStore: ISnackbarStore = {
  message: null,
  isError: false,
};

export default initStore;
